import React from 'react'

import Cookies from 'js-cookie'
import { useRouter } from 'next/router'

import * as S from './styles'
import { Image } from '../image'
import { Text } from '../text'
import { GlobeIcon, WhiteGlobe } from '@/assets/icons'
import { Constants } from '@/utils/constants'

export type LanguageSwitchProps = {
  /**
   * isBiggerMobile is used as reference for lower resolutions
   *
   * @default false
   *
   * @example
   * ```tsx
   * <LanguageSwitch isBiggerMobile=true />
   * ```
   *
   */
  isBiggerMobile?: boolean

  /**
   * If the container is in darkMode
   * @default false
   * @example
   * ```tsx
   * <LanguageSwitch darkMode={true} />
   * ```
   * */
  darkMode?: boolean

  /**
   * Class name of the container
   * @default undefined
   * @example
   * ```tsx
   * <LanguageSwitch className="language-switch" />
   * ```
   * */
  className?: string
}

export const LanguageSwitch: React.FC<LanguageSwitchProps> = ({
  isBiggerMobile,
  darkMode = false,
  className,
}) => {
  const router = useRouter()
  const nextLocale =
    router.locale === 'pt-BR'
      ? { text: 'English', code: 'en' }
      : { text: 'Português', code: 'pt-BR' }

  const cookies = Cookies
  const switchLocale = () => {
    const path = router.asPath

    cookies.set('NEXT_LOCALE', nextLocale.code === 'en' ? 'en' : 'pt-BR', {
      expires: new Date(Date.now() + Constants.ONE_YEAR * 1000),
    })
    return router.push(path, path, { locale: nextLocale.code })
  }

  return (
    <S.LanguageSwitchContainer onClick={switchLocale} className={className}>
      <Image
        src={darkMode ? WhiteGlobe : GlobeIcon}
        alt={router.locale !== 'en' ? 'ícone de globo' : 'globe icon'}
        defaultSize={{
          height: 20,
          width: 28,
        }}
      />
      <Text
        size={isBiggerMobile ? 'b4' : 'b3'}
        color={darkMode ? 'white' : 'black'}
        className="language-text"
      >
        {nextLocale.text}
      </Text>
    </S.LanguageSwitchContainer>
  )
}
